import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type Quiz = paths['/quiz/{slug}/'];

const getQuiz = createRequest<Quiz>('/pc/quiz/{slug}/');

export default getQuiz;
